import { Controller } from "@hotwired/stimulus"
import "@37signals/lexxy"

export default class extends Controller {
  static targets = ["editor", "input"]

  connect() {
    this.editorTarget.addEventListener("lexxy:change", this.updateInput)

    if (this.editorTarget.hasAttribute("connected")) {
      this.initializeEditor()
    } else {
      this.editorTarget.addEventListener("lexxy:initialize", this.initializeEditor, { once: true })
    }
  }

  disconnect() {
    this.editorTarget.removeEventListener("lexxy:change", this.updateInput)
    this.editorTarget.removeEventListener("lexxy:initialize", this.initializeEditor)
  }

  initializeEditor = () => {
    this.editorTarget.querySelector(".lexxy-editor__content")?.classList.add("lexxy-content")
    this.loadValue()
  }

  loadValue = () => {
    if (this.inputTarget.value) this.editorTarget.value = this.inputTarget.value
  }

  updateInput = () => {
    this.inputTarget.value = this.editorTarget.value
  }
}
